import { Yacht } from "../../Yachts/model";
import { useState } from "react";
import { YachtDetailsModal } from "../../Offers/EditOffer/YachtDetailsModal";
import { Button } from "@/src/components/ui/button";

type YachtsSelectionProps = {
  yachts: Yacht[];
  selectedYachtIds: string[];
  onSelectionChange: (ids: string[]) => void;
};
export function YachtsSelection({ yachts, selectedYachtIds, onSelectionChange }: YachtsSelectionProps) {
  const [displayCount, setDisplayCount] = useState(12);
  const [yachtModal, setYachtModal] = useState<string | null>(null);

  const handleLoadMore = () => {
    setDisplayCount((prevCount) => prevCount + 12);
  };

  const displayedYachts = yachts.slice(0, displayCount);

  if (yachts.length === 0) {
    return <div className="text-gray-500 text-center py-8">No yachts.</div>;
  }

  return (
    <div className="mt-4 space-y-4">
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
        {displayedYachts.map((yacht) => (
          <div key={yacht.id} className="flex flex-col items-start relative">
            <div className="absolute top-2 right-2 z-10">
              <input
                type="checkbox"
                checked={selectedYachtIds.includes(yacht.id)}
                onChange={(e) => {
                  const newSelectedIds = e.target.checked
                    ? [...selectedYachtIds, yacht.id]
                    : selectedYachtIds.filter((id) => id !== yacht.id);
                  onSelectionChange(newSelectedIds);
                }}
                className="h-6 w-6 rounded border-gray-300 text-blue-600 focus:ring-blue-500"
              />
            </div>
            <img
              src={yacht.media && yacht.media.length > 0 ? yacht.media[0] : "/placeholder-yacht.jpg"}
              alt={yacht.name}
              className="w-full h-48 object-cover rounded-md mb-2"
            />
            <Button
              variant="link"
              onClick={() => setYachtModal(yacht.id)}
              className="font-medium truncate w-full overflow-hidden text-ellipsis text-blue-500 underline"
            >
              {yacht.name} - {yacht.modelName} - {yacht.year}
            </Button>
          </div>
        ))}
      </div>
      {yachtModal && <YachtDetailsModal yachtDetailsId={yachtModal} open setOpen={() => setYachtModal(null)} />}

      {displayCount < yachts.length && (
        <div className="flex justify-center">
          <button
            onClick={handleLoadMore}
            className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 transition-colors"
          >
            Load More
          </button>
        </div>
      )}
    </div>
  );
}
